module.exports = __webpack_public_path__ + "static/media/liteblueShirt.68726e7b.jpg";